import { render, staticRenderFns } from "./MitMenuAdmin.vue?vue&type=template&id=87ff8cfc&scoped=true"
import script from "./MitMenuAdmin.vue?vue&type=script&lang=js"
export * from "./MitMenuAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ff8cfc",
  null
  
)

export default component.exports